module.exports = __webpack_public_path__ + "img/disaster_recovery.741b7319.svg";